<div class="seperator"></div>
<div class="title" mat-dialog-title>Add Partner ID</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You can add multiple Partner IDs</div>
        <!-- <mat-form-field appearance="outline" class="form-field">
            <mat-label>Enter Partner ID</mat-label>
            <input matInput placeholder="Placeholder" [formControl]="partnerIds">
        </mat-form-field> -->

        <mat-form-field appearance="outline" class="form-field">
            <mat-label>Partner IDs</mat-label>
            <mat-select multiple [formControl]="partnerIds">
                <mat-option *ngFor="let partner of data.availablePartners" [value]="partner.partnerId + ''">
                    {{partner.partnerId + ' - ' + partner.displayName}}
                </mat-option>
            </mat-select>
        </mat-form-field>

    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button [disabled]="!partnerIds.value || !partnerIds.value.length" class="rubii-btn add-btn" color="primary" (click)="connect()">
            Connect Data Source
        </button>
    </div>
</div>